import { mergeStyles, Shimmer, ShimmerElementType, Stack } from "@fluentui/react";
import {
  Badge,
  Body1,
  Card,
  CardFooter,
  CardHeader,
  FluentProvider,
  Link,
  tokens,
  webLightTheme
} from "@fluentui/react-components";
import { ChevronRight12Filled } from "@fluentui/react-icons";
import { useNavigate } from "react-router-dom";
import HomeSparkLineChart from "../../../../../ChartComponents/HomeSparkLineChart";
import { ProductCardProps } from "../../../Common/ProductView.interfaces";
import { PRODUCT_VIEW_STYLES as styles } from "../../../Common/ProductView.styles";

export const ProductCard = (props: ProductCardProps) => {
  const navigate = useNavigate();
  const shimmerElements = [
    { type: ShimmerElementType.line, height: 20 },
    { type: ShimmerElementType.gap, width: "10%", height: 20 },
    { type: ShimmerElementType.line, height: 20 },
    { type: ShimmerElementType.gap, width: "10%", height: 20 },
    { type: ShimmerElementType.line, height: 20 }
  ];
  const shimmerStack = (
    <Stack styles={styles.PRODUCT_LIST.CSS_STYLES.shimmerStack}>
      <Shimmer shimmerElements={shimmerElements} />
      <Shimmer shimmerElements={shimmerElements} />
    </Stack>
  );

  const handleProductNavigation = () => navigate("/productview?productid=" + encodeURIComponent(props.productId) + "&productname=" + encodeURIComponent(props.productName) + (props.productFamily ? "&productfamily=" + encodeURIComponent(props.productFamily) : ""));

  if (props.loading) {
    return (
      <FluentProvider theme={webLightTheme}>
        <Card {...props} style={styles.PRODUCT_LIST.CSS_STYLES.cardStyles}>
          <Stack tokens={{ childrenGap: 4 }}>
            <Shimmer shimmerElements={[{ type: ShimmerElementType.line, height: 20 }]} />
            <Shimmer width="40%" shimmerElements={[{ type: ShimmerElementType.line, height: 20 }]} />
          </Stack>
          {shimmerStack}
          <Stack horizontal styles={styles.PRODUCT_LIST.CSS_STYLES.cardHeaderDescriptionShimmerContainer}>
            <Shimmer
              shimmerElements={[
                { type: ShimmerElementType.line, height: 24, width: 24 },
                { type: ShimmerElementType.gap, width: 6 }
              ]}
            />
            <Shimmer shimmerElements={[{ type: ShimmerElementType.line, height: 24 }]} />
          </Stack>
        </Card>
      </FluentProvider>
    );
  }

  return (
    <FluentProvider theme={webLightTheme} style={{ height: "100%" }}>
      <Card {...props} style={styles.PRODUCT_LIST.CSS_STYLES.cardStyles}>
        <CardHeader
          header={<Body1 style={styles.PRODUCT_LIST.CSS_STYLES.cardHeader}>{props.productName}</Body1>}
          description={
            <Stack horizontal styles={styles.PRODUCT_LIST.CSS_STYLES.cardHeaderDescription}>
              <div className={styles.PRODUCT_LIST.CLASS_NAMES.textCenter} title={props.productKpiName}>
                {props.productKpiName}
              </div>
              <div className={styles.PRODUCT_LIST.CLASS_NAMES.textCenter}>Trend</div>
              <div className={styles.PRODUCT_LIST.CLASS_NAMES.textCenter}>MoM</div>
              <div className={styles.PRODUCT_LIST.CLASS_NAMES.abbrCurrentValue} title={props.abbrCurrentValue}>
                {props.abbrCurrentValue}
              </div>
              <div className={styles.PRODUCT_LIST.CLASS_NAMES.textCenter}>
                <HomeSparkLineChart chartData={props.chartData} name={props.productKpiName} />
              </div>
              <div
                className={mergeStyles({
                  color: props.abbrMOMVariance?.includes("-") ? "red" : "green",
                  fontWeight: tokens.fontWeightSemibold,
                  textAlign: "center"
                })}
                title={props.abbrMOMVariance}
              >
                {props.abbrMOMVariance}
              </div>
            </Stack>
          }
          style={{ flex: 1 }}
        />
        <CardFooter>
          <Stack horizontal tokens={{ childrenGap: 6 }} styles={styles.PRODUCT_LIST.CSS_STYLES.footerStack}>
            <Badge
              aria-label="Explore more"
              className={styles.PRODUCT_LIST.CLASS_NAMES.footerBadge}
              icon={<ChevronRight12Filled aria-label="Explore more" />}
              onClick={handleProductNavigation}
              shape="rounded"
              size="large"
            />
            <Link onClick={handleProductNavigation} style={styles.PRODUCT_LIST.CSS_STYLES.exploreMoreLink}>
              Explore more
            </Link>
          </Stack>
        </CardFooter>
      </Card>
    </FluentProvider>
  );
};
